export const ROOT = '/';
export const LOGIN = 'login';
export const USER_MANAGEMENT = 'user-management';
export const AUDIT_LOGS = 'audit-logs';
export const CONTENT_ITEMS = 'content-items';
